import type { ChoiceOption } from '../api/types';

/**
 * What each assistant-ui message in a chat carries on `metadata.custom.item`. A reply is one message: the
 * activity lines that led to it, its text, and the choice it asks for, if any.
 *
 * `index` is the message's position in the chat's saved messages (what ratings are keyed on), or null for
 * one not saved yet.
 */
/** `sender` is who sent it, as saved with it; empty when that wasn't recorded. */
export type UserItem = {
  kind: 'user'; text: string; index: number | null; sender: string;
};

export type ReplyItem = {
  kind: 'reply';
  events: string[];
  /** Lines to rotate through while the latest activity runs. */
  variations: string[];
  reply: string;
  options: ChoiceOption[];
  question: string;
  locked: boolean;
  running: boolean;
  index: number | null;
  runId: string;
  /** The builder's message this replies to: what "Send it again" sends. */
  prompt: string;
  /** The reply broke off before it answered. */
  interrupted: boolean;
};

export type MessageItem = UserItem | ReplyItem;

export const itemOf = (metadata: { custom?: Record<string, unknown> } | undefined) => (
  metadata?.custom?.item as MessageItem | undefined
);

export const emptyReply = (overrides: Partial<ReplyItem> = {}): ReplyItem => ({
  kind: 'reply',
  events: [],
  variations: [],
  reply: '',
  options: [],
  question: '',
  locked: false,
  running: false,
  index: null,
  runId: '',
  prompt: '',
  interrupted: false,
  ...overrides,
});
